import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { FMTextInput } from 'atoms';
import { IconData } from '../../../store/FMImages/FMImagesReducer';
import style from './FMIconPicker.style';

interface Props {
    iconsPath: string;
    icons: IconData[];
    classes: any;
    initialValue?: string;
    onChange?: (value: string) => void;
}

interface State {
    selectedIcon: string;
}

class FMIconPicker extends React.Component<Props, State> {

    public constructor(props) {
        super(props);

        let selectedIcon = this.props.initialValue
            ? this.props.initialValue
            : this.props.icons[0].id;

        this.state = {
            selectedIcon: selectedIcon,
        };
    }

    private changeSelectedIcon = event => {
        let newValue = event.target.value;
        this.setState({ selectedIcon: newValue });
        if (this.props.onChange) {
            this.props.onChange(newValue);
        }
    }

    public getSelectedIconRelativePath = () => this.state.selectedIcon;

    public render() {
        return (
            <Select
                className={this.props.classes.selectRoot}
                variant="outlined"
                input={<FMTextInput />}
                value={this.state.selectedIcon}
                onChange={this.changeSelectedIcon}
            >
                {
                    this.props.icons.map(icon => (
                        <MenuItem key={icon.id} value={icon.id}>
                            <img className={this.props.classes.image} src={`${this.props.iconsPath}${icon.id}`} />
                            <Typography inline={true}>{icon.name}</Typography>
                        </MenuItem>
                    ))
                }
            </Select>
        );
    }

}

export default withStyles(style)(FMIconPicker);
